import React, { useState, useRef } from "react";
import Slider from "react-slick";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { useGetProtectedApiDataQuery } from "../../redux/services/apiSlice";
import { useLanguageTranslation } from "../../hooks/useLanguageTranslation";
import SliderNavigation from "../SliderNavigation";
import Loader from "../Loader";

const Challenges = () => {
  const { getText } = useLanguageTranslation();
  const [currentIndex, setCurrentIndex] = useState(0);

  const slider = useRef();
  const navigate = useNavigate();
  const { languageType } = useSelector((state) => state.homeSlice);

  const {
    data: challengesData = [],
    challengesError,
    challengesIsLoading,
  } = useGetProtectedApiDataQuery({ url: "challenges", lang: languageType });

  const settings = {
    // dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    arrows: false,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 5000,
    afterChange: (current) => setCurrentIndex(current),
  };

  const next = () => {
    slider.current.slickNext();
  };
  const prev = () => {
    slider.current.slickPrev();
  };
  if (challengesIsLoading) {
    return <Loader />;
  }

  if (challengesError) {
    return <div>Error loading challenges.</div>;
  }
  return (
    <>
      <div className="col-12 col-sm-12 col-md-6 col-lg-6 challenges-sec wow zoomIn">
        <div className="title-sec d-flex justify-content-end">
          <h4>{getText("Challenges", "चुनौतियां")}</h4>
          <SliderNavigation slider={slider} section={"Challenges"} />

          {/* <button className="btnPause">
            <div className="arrow">
              <span className="left" onClick={prev}>
                <i className="fa fa-angle-left"></i>
              </span>

              <span className="right" onClick={next}>
                <i className="fa fa-angle-right"></i>
              </span>
            </div>
          </button> */}
        </div>

        {challengesData.length > 0 ? (
          <>
            <Slider {...settings} ref={slider}>
              {challengesData.map((item, index) => (
                <div className="challengesbox" key={index}>
                  <img
                    src={
                      process.env.REACT_APP_IMAGE_URL +
                      item?.field_challenges_image
                    }
                    alt={item.title}
                  />
                  <div className="desc-sec">
                    <h4 className="text-justify line-clamp line-clamp-1">
                      {/* {item?.title?.slice(0, 63)}... */}
                      {item?.title}
                    </h4>
                    <p className="text-justify line-clamp line-clamp-2">
                      {item?.field_content}
                      {/* {item.field_content.slice(0, 170)}... */}
                    </p>
                  </div>
                </div>
              ))}
            </Slider>
            <a
              href={"#"}
              onClick={(e) => {
                const currentItem = challengesData[currentIndex];
                e.preventDefault();
                navigate(`/challenges/${currentItem?.nid}`);
              }}
              className="quick-btn"
              style={{ cursor: "pointer" }}
            >
              {getText("Detail", "विवरण")}
            </a>
          </>
        ) : (
          <div>No challenges available.</div>
        )}
      </div>
    </>
  );
};

export default Challenges;
